export function getQueryStringVariable(variable) {
	let href_qs = decodeURIComponent(window.location.href);
	let query = href_qs.split('?')[1];
    if (query !== undefined) {
    	let vars = query.split('&');
    	for (let i = 0; i < vars.length; i++) {
    		let pair = vars[i].split('=');
    		if (decodeURIComponent(pair[0]) == variable) {
    			return decodeURIComponent(pair[1]);
    		}
    	}    	
    }
    return null;
}
